import type { Campaign, DailyStatItem } from "./types";

export const YANDEX_CAMPAIGNS: Campaign[] = [
  {
    id: "1",
    name: "ЕПК — Приоритетные категории (Поиск + Сети)",
    type: "Единая перфоманс-кампания (ЕПК)",
    placement: "Поиск Яндекса и РСЯ",
    budget: "150 000 ₽/нед",
    spent: "98 400 ₽",
    clicks: "5 120",
    ctr: "6.4%",
    activeModules: ["Автобиддер ставок", "Чистка площадок РСЯ"],
    metrics: [
      {
        label: "Бюджет и расход",
        value: "98 400 ₽",
        subValue: "из 150 000 ₽",
        change: "+12.4%",
        isPositive: true,
        chartType: "line",
        chartPoints: [35, 45, 60, 50, 75, 80, 98],
      },
      {
        label: "Клики",
        value: "5 120",
        subValue: "79 800 показов",
        change: "+8.1%",
        isPositive: true,
        chartType: "line",
        chartPoints: [420, 510, 680, 720, 690, 890, 1210],
      },
      {
        label: "Средний CTR",
        value: "6.4%",
        subValue: "Поиск: 9.1% • Сети: 2.3%",
        change: "+0.8%",
        isPositive: true,
        chartType: "line",
        chartPoints: [5.2, 5.5, 5.8, 6.1, 5.9, 6.2, 6.4],
      },
      {
        label: "Конверсии (CPA)",
        value: "312",
        subValue: "Ср. цена: 315 ₽",
        change: "+15.3%",
        isPositive: true,
        chartType: "line",
        chartPoints: [28, 34, 45, 39, 52, 56, 58],
      },
    ],
    history: [
      {
        id: "h1",
        date: "11.09.2026, 14:32",
        author: "Алексей Д.",
        action: "Изменение недельного бюджета",
        oldValue: "130 000 ₽",
        newValue: "150 000 ₽",
      },
      {
        id: "h2",
        date: "10.09.2026, 11:15",
        author: "Автостратегия",
        action: "Корректировка целевой цены конверсии (tCPA)",
        oldValue: "340 ₽",
        newValue: "315 ₽",
      },
      {
        id: "h3",
        date: "08.09.2026, 18:40",
        author: "Алексей Д.",
        action: "Добавлены минус-фразы (14 шт.)",
        oldValue: "248 фраз",
        newValue: "262 фразы",
      },
      {
        id: "h4",
        date: "06.09.2026, 09:20",
        author: "Система",
        action: "Запуск A/B теста быстрых ссылок",
        oldValue: "Вариант А",
        newValue: "Тест А/В (50/50)",
      },
    ],
  },
  {
    id: "2",
    name: "Мастер кампаний — Конверсии на сайте",
    type: "Мастер кампаний",
    placement: "Все места показа • Оплата за целевые действия",
    budget: "80 000 ₽/нед",
    spent: "54 200 ₽",
    clicks: "3 840",
    ctr: "4.8%",
    activeModules: ["Автобиддер ставок"],
    metrics: [
      {
        label: "Бюджет и расход",
        value: "54 200 ₽",
        subValue: "из 80 000 ₽",
        change: "+5.1%",
        isPositive: true,
        chartType: "line",
        chartPoints: [20, 28, 35, 42, 48, 51, 54],
      },
      {
        label: "Клики",
        value: "3 840",
        subValue: "80 100 показов",
        change: "-2.3%",
        isPositive: false,
        chartType: "line",
        chartPoints: [600, 580, 540, 520, 510, 550, 540],
      },
      {
        label: "Средний CTR",
        value: "4.8%",
        subValue: "Автооптимизация",
        change: "+0.3%",
        isPositive: true,
        chartType: "line",
        chartPoints: [4.1, 4.3, 4.4, 4.6, 4.5, 4.7, 4.8],
      },
      {
        label: "Конверсии (CPA)",
        value: "184",
        subValue: "Ср. цена: 294 ₽",
        change: "+9.0%",
        isPositive: true,
        chartType: "line",
        chartPoints: [18, 22, 26, 25, 31, 30, 32],
      },
    ],
    history: [
      {
        id: "h2-1",
        date: "09.09.2026, 16:00",
        author: "Алексей Д.",
        action: "Добавление аудитории ретаргетинга",
        oldValue: "Все посетители",
        newValue: "Посетители > 2 мин",
      },
      {
        id: "h2-2",
        date: "05.09.2026, 12:40",
        author: "Автостратегия",
        action: "Обновление ключевых целей метрики",
        oldValue: "Отправка формы",
        newValue: "Отправка формы + Звонок",
      },
    ],
  },
  {
    id: "3",
    name: "Товарная кампания — Полный каталог товаров",
    type: "Товарная кампания",
    placement: "Товарная галерея на Поиске и в РСЯ",
    budget: "120 000 ₽/нед",
    spent: "86 300 ₽",
    clicks: "6 290",
    ctr: "5.1%",
    metrics: [
      {
        label: "Бюджет и расход",
        value: "86 300 ₽",
        subValue: "из 120 000 ₽",
        change: "+18.2%",
        isPositive: true,
        chartType: "line",
        chartPoints: [30, 42, 55, 68, 74, 80, 86],
      },
      {
        label: "Клики",
        value: "6 290",
        subValue: "123 300 показов",
        change: "+14.6%",
        isPositive: true,
        chartType: "line",
        chartPoints: [700, 790, 850, 920, 960, 1010, 1060],
      },
      {
        label: "Средний CTR",
        value: "5.1%",
        subValue: "Товарная галерея",
        change: "+0.5%",
        isPositive: true,
        chartType: "line",
        chartPoints: [4.4, 4.6, 4.8, 4.7, 4.9, 5.0, 5.1],
      },
      {
        label: "Заказы (ДРР)",
        value: "420",
        subValue: "ДРР: 11.2%",
        change: "-1.4%",
        isPositive: true,
        chartType: "line",
        chartPoints: [45, 52, 58, 62, 65, 68, 70],
      },
    ],
    history: [
      {
        id: "h3-1",
        date: "11.09.2026, 10:10",
        author: "Система",
        action: "Автоматическое обновление YML-фида",
        oldValue: "14 200 товаров",
        newValue: "14 850 товаров",
      },
    ],
  },
  {
    id: "4",
    name: "Смарт-баннеры — Динамический ретаргетинг",
    type: "Смарт-баннеры",
    placement: "Рекламная сеть Яндекса (РСЯ)",
    budget: "50 000 ₽/нед",
    spent: "32 100 ₽",
    clicks: "2 140",
    ctr: "3.2%",
    metrics: [
      {
        label: "Бюджет и расход",
        value: "32 100 ₽",
        subValue: "из 50 000 ₽",
        change: "+4.3%",
        isPositive: true,
        chartType: "line",
        chartPoints: [12, 16, 20, 24, 28, 30, 32],
      },
      {
        label: "Клики",
        value: "2 140",
        subValue: "66 800 показов",
        change: "+2.1%",
        isPositive: true,
        chartType: "line",
        chartPoints: [280, 290, 305, 310, 300, 325, 330],
      },
      {
        label: "Средний CTR",
        value: "3.2%",
        subValue: "Баннеры РСЯ",
        change: "+0.2%",
        isPositive: true,
        chartType: "line",
        chartPoints: [2.9, 3.0, 3.0, 3.1, 3.1, 3.2, 3.2],
      },
      {
        label: "Возвратные заказы",
        value: "142",
        subValue: "Ср. чек: 4 800 ₽",
        change: "+7.5%",
        isPositive: true,
        chartType: "line",
        chartPoints: [14, 18, 20, 21, 22, 23, 24],
      },
    ],
    history: [
      {
        id: "h4-1",
        date: "07.09.2026, 15:30",
        author: "Алексей Д.",
        action: "Фильтрация товаров со скидкой > 20%",
        oldValue: "Все категории",
        newValue: "Распродажа",
      },
    ],
  },
  {
    id: "5",
    name: "Медийная кампания — Узнаваемость бренда (CPM)",
    type: "Медийная кампания",
    placement: "Главная страница Яндекса и видеосеть",
    budget: "200 000 ₽",
    spent: "142 000 ₽",
    clicks: "11 400",
    ctr: "1.6%",
    metrics: [
      {
        label: "Бюджет и расход",
        value: "142 000 ₽",
        subValue: "из 200 000 ₽",
        change: "+22.0%",
        isPositive: true,
        chartType: "line",
        chartPoints: [40, 60, 80, 95, 115, 130, 142],
      },
      {
        label: "Показы",
        value: "712 500",
        subValue: "11 400 переходов",
        change: "+19.4%",
        isPositive: true,
        chartType: "line",
        chartPoints: [70, 85, 95, 105, 115, 118, 124],
      },
      {
        label: "Средний CTR",
        value: "1.6%",
        subValue: "CPM: 199 ₽",
        change: "+0.1%",
        isPositive: true,
        chartType: "line",
        chartPoints: [1.4, 1.4, 1.5, 1.5, 1.6, 1.6, 1.6],
      },
      {
        label: "Досмотры видео",
        value: "84.2%",
        subValue: "Формат: 15 сек",
        change: "+3.1%",
        isPositive: true,
        chartType: "line",
        chartPoints: [78, 80, 81, 82, 83, 84, 84],
      },
    ],
    history: [
      {
        id: "h5-1",
        date: "04.09.2026, 13:00",
        author: "Алексей Д.",
        action: "Обновление видеокреатива",
        oldValue: "promo_v1.mp4",
        newValue: "promo_v2_final.mp4",
      },
    ],
  },
  {
    id: "6",
    name: "Реклама в Telegram-каналах — Бизнес и финансы",
    type: "Реклама в Telegram-каналах",
    placement: "Яндекс Директ в Telegram",
    budget: "60 000 ₽/нед",
    spent: "39 500 ₽",
    clicks: "1 980",
    ctr: "3.7%",
    metrics: [
      {
        label: "Бюджет и расход",
        value: "39 500 ₽",
        subValue: "из 60 000 ₽",
        change: "+11.0%",
        isPositive: true,
        chartType: "line",
        chartPoints: [10, 15, 20, 26, 31, 35, 39],
      },
      {
        label: "Клики",
        value: "1 980",
        subValue: "53 500 просмотров",
        change: "+8.9%",
        isPositive: true,
        chartType: "line",
        chartPoints: [210, 240, 270, 300, 310, 320, 330],
      },
      {
        label: "Средний CTR",
        value: "3.7%",
        subValue: "Каналы: Бизнес",
        change: "+0.4%",
        isPositive: true,
        chartType: "line",
        chartPoints: [3.1, 3.2, 3.4, 3.5, 3.6, 3.6, 3.7],
      },
      {
        label: "Подписки на бота",
        value: "284",
        subValue: "Ср. цена: 139 ₽",
        change: "+14.0%",
        isPositive: true,
        chartType: "line",
        chartPoints: [30, 34, 38, 42, 45, 47, 48],
      },
    ],
    history: [
      {
        id: "h6-1",
        date: "10.09.2026, 17:20",
        author: "Алексей Д.",
        action: "Добавлен список исключённых каналов",
        oldValue: "0 каналов",
        newValue: "12 каналов",
      },
    ],
  },
];

export const MOCK_DAILY_STATS: DailyStatItem[] = [
  { date: "05.09", spent: 12400, clicks: 680, impressions: 10450, ctr: 6.5, conversions: 38, cpa: 326 },
  { date: "06.09", spent: 13100, clicks: 710, impressions: 11200, ctr: 6.3, conversions: 42, cpa: 312 },
  { date: "07.09", spent: 14200, clicks: 780, impressions: 12100, ctr: 6.4, conversions: 46, cpa: 308 },
  { date: "08.09", spent: 13800, clicks: 740, impressions: 11800, ctr: 6.3, conversions: 44, cpa: 313 },
  { date: "09.09", spent: 14500, clicks: 810, impressions: 12600, ctr: 6.4, conversions: 47, cpa: 308 },
  { date: "10.09", spent: 15100, clicks: 890, impressions: 13400, ctr: 6.6, conversions: 51, cpa: 296 },
  { date: "11.09", spent: 15300, clicks: 920, impressions: 13900, ctr: 6.6, conversions: 54, cpa: 283 },
];

export const getCampaignById = (id: string): Campaign | undefined => {
  return YANDEX_CAMPAIGNS.find((c) => c.id === id) ?? YANDEX_CAMPAIGNS[0];
};

export const getCampaignDailyStats = (campaign?: Campaign): DailyStatItem[] => {
  if (campaign?.dailyStats && campaign.dailyStats.length > 0) {
    return campaign.dailyStats;
  }
  return MOCK_DAILY_STATS;
};
